<template>
    <svg class="svg_component svg-symbol symbol"
         width="12.846519mm"
         height="27.974562mm"
         viewBox="0 0 12.846519 27.974562"
    >
      <use :xlink:href="'#'+symbolId"></use>
    </svg>
</template>

<script>
export default {
  name: 'SingleSymbolSVG',
  props: {
    symbolId: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.svg-symbol {
  border: none;

  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 3s;
  width: auto;
  height: 75%;

  svg {
    /*width: 60px;
    height: 120px;*/
    height: 100%;
    width: auto;
    /*float: left;*/
    transition: width 3s;

    path {
      /*stroke: blue;*/
      /*fill: darkred;*/
    }
  }
}
</style>
